export const CHECKOUT_URL = 'https://pay.hotmart.com/A107633977L?checkoutMode=10'
